import { useContext } from 'react';
import { Context, ContextValue } from '../components/TwilioConversationProvider';

const useTwilioConversation = () => {
    return useContext<ContextValue>(Context);
};

export default useTwilioConversation;
